// Placeholder business info, per the design doc's own "Pendientes antes de
// publicar" list -- confirm real values before promoting this site to prod.
export const BUSINESS = {
  telefono: '220 416 2042',
  whatsapp: '522204162042',
  direccion: 'Puebla, Puebla · dirección por confirmar', // Placeholder · confirmar
  email: 'hola@zenya.com.mx', // Placeholder · confirmar
  mapsLink: 'https://maps.google.com/?q=Zenya+Nails+Spa+Puebla',
  horario: [
    { dia: 'Lunes a viernes', hora: '10:00 – 20:00' },
    { dia: 'Sábado', hora: '10:00 – 18:00' },
    { dia: 'Domingo', hora: 'Cerrado' },
  ],
  redes: [
    { nombre: 'Instagram', url: 'https://www.instagram.com/zenya.nailspa/' },
    { nombre: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61569758502132' },
    { nombre: 'TikTok', url: '#' }, // Placeholder · definir o retirar
  ],
  // AgendaPro embed -- empty until the real iframe src is known; /agendar
  // renders a graceful fallback (link out + WhatsApp) while this is unset.
  agendaproSrc: '',
  agendaproUrl: 'https://www.agendapro.com/mexico',
};

export const telLink = `tel:+52${BUSINESS.telefono.replace(/\D/g, '')}`;

// Off by default in the design itself (mostrarTestimonios ?? false) -- flip
// only once real client screenshots/videos exist. See Testimonials component.
export const SHOW_TESTIMONIOS = false;
